import React from 'react'

const IconAccepted= ({fillColor,style}) => {
  return (
    
   <svg xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="M382-352.31 198.85-535.46 227.38-564 382-409.38 732.62-760l28.53 28.54L382-352.31ZM240-200v-40h480v40H240Z"/>
   </svg>
  )
}
export default IconAccepted 